export default __webpack_public_path__ + "static/media/srb.02c35870.svg";